'use client'

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SvgArrowLeftIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "img",
    ref,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16.207 4.293a1 1 0 0 1 0 1.414L9.914 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const ForwardRef = forwardRef(SvgArrowLeftIcon);
ForwardRef.displayName = "ArrowLeftIcon";

export { ForwardRef as default };
//# sourceMappingURL=ArrowLeftIcon.mjs.map
